// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import messageDotsSquareIcon from "@/assets/icons/message-dots-square.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type MessageDotsSquareIconProps = Omit<IconProps, "name">;

export function MessageDotsSquareIcon(props: MessageDotsSquareIconProps): React.ReactNode {
  return <Icon name={messageDotsSquareIcon} {...props} />;
}
